import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Collapse, Navbar, Container, Nav, Form, Button,
} from 'react-bootstrap5';

import { useTableContext } from './TableContext';
import Actions from './Actions';
import Filter from './Filter';
import SearchFilter from './Filter/Search';

export default function SubHeader({
  columns, selectableRows, onExportClick, filterOpen,
}) {
  const { state, dispatch } = useTableContext();
  const [open, setOpen] = React.useState(filterOpen);

  const filters = columns.filter(
    (column) => column.filter,
  ).map(
    /* eslint-disable react/no-array-index-key */
    (filterColumn, i) => <Filter key={`table-filter-${i}`} filterColumn={filterColumn} />,
    /* eslint-enable react/no-array-index-key */
  );

  const exportableColumns = columns.filter((column) => column.exportable);

  const { selectedFilters } = state;

  const activeFiltersCount = Object.keys(selectedFilters).filter(
    (key) => selectedFilters[key]?.length,
  ).length;

  return (
    <>
      <Navbar className="pb-0">
        <Container fluid className="p-0 d-block d-lg-flex">
          <div className="mb-2 mb-lg-1">
            { columns.some((column) => column.searchable) && <SearchFilter /> }
          </div>

          <Nav className="flex-column flex-md-row justify-content-between align-items-md-center">
            { selectableRows && (
              <Form.Check
                id="show-only-selected-filter"
                label="Show only selected"
                className="mt-lg-1 mb-2 mb-lg-0"
                onChange={
                  (e) => Actions.showOnlySelectedRows(dispatch, e.currentTarget.checked)
                }
              />
            )}

            { (filters.length > 0 || exportableColumns.length) > 0 && (
              <div className="align-self-end">
                {exportableColumns.length > 0
                  && (
                  <Button
                    size="sm"
                    className="ms-3"
                    onClick={onExportClick}
                  >
                    Export
                  </Button>
                  )}

                {filters.length > 0 && (
                  <>
                    <Button
                      size="sm"
                      className="ms-3"
                      onClick={() => Actions.clearFilters(dispatch)}
                    >
                      Clear all
                    </Button>

                    <Button
                      variant=""
                      className="btn-filter ms-3 py-3 px-2"
                      onClick={() => setOpen(!open)}
                      aria-expanded={open}
                    >
                      <div className="icon-with-text">
                        <i className="small-icon filter-icon" />
                        { activeFiltersCount > 0 && (
                        <div className="active-filters-counter">{activeFiltersCount}</div>
                        )}
                      </div>
                    </Button>
                  </>
                )}
              </div>
            )}
          </Nav>
        </Container>
      </Navbar>

      <Collapse in={open}>
        <div className="sub-header-filters p-3 pb-0">
          <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3">
            { filters }
          </Row>
        </div>
      </Collapse>
    </>
  );
}

SubHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectableRows: PropTypes.bool,
  onExportClick: PropTypes.func,
  filterOpen: PropTypes.bool,
};

SubHeader.defaultProps = {
  selectableRows: true,
  onExportClick: () => {},
  filterOpen: false,
};
